// extracted by mini-css-extract-plugin
export var typingIndicator = "_rt-0";